<script setup>
import {useWebStore} from "~/store/web.js";

const animateKey = ref(0)
const store=useWebStore();

const showRocket = ref(false)

onMounted(() => {
  setInterval(() => {
    showRocket.value = true
    setTimeout(() => {
      showRocket.value = false
    }, 3000) // Animation duration
  }, 6000) // 4s animation + 4s pause
})

const navigateToWebshop = () =>{
  window.open('https://flakon.hu  ', '_blank')
}

</script>

<template>
  <UButton
      class="absolute top-20 sm:top-80 lg:top-20 lg:bottom-[unset] md:top-60 right-5 lg:right-10 bg-orange-500 hover:bg-gray-500 cursor-pointer
           px-3 lg:px-6 py-2 lg:py-3 z-[100] shadow-2xl rounded-4xl
           flex items-center gap-3 text-base lg:text-xl transform hover:scale-105 active:scale-95
           transition-all w-fit overflow-hidden font-resonate-bold tracking-wider pulse"
      @click="navigateToWebshop"
  >
    <span class="text-xs lg:text-lg text-white font-bold ">{{ store.getLocaleString('cta_t') }}</span>
    <img v-if="showRocket"
         src="/cta-button-icon.svg"
         class="h-5 lg:h-8 animate-rocket"
         :key="animateKey"
    />
    <img v-if="!showRocket"
         src="/cta-button-icon.svg"
         class="h-5 lg:h-8"
    />
  </UButton>
</template>

<style scoped>
@keyframes rocket {
  0% {
    opacity: 1;
  }
  20% {
    transform: rotate(0deg);
    opacity: 1;
  }
  30% {
    transform: rotate(-15deg);
    opacity: 1;
  }
  60% {
    transform: translateX(200px);
    opacity: 1;
  }
  61% {
    opacity: 0;
  }
  70% {
    transform: translateX(-200px) rotate(0deg);
    opacity: 0;
  }
  71% {
    opacity: 1;
  }
  100% {
    transform: translateX(0) rotate(0deg);
    opacity: 1;
  }
}

.animate-rocket {
  animation: rocket 3s linear infinite;
  z-index: 5;
  will-change: transform; /* Optimize animation performance */
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(249,115,22, 0.7); /* narancs (#f97316) glow */
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 20px 10px rgba(249,115,22, 0.3);
  }
}

.pulse {
  animation: pulse 4s infinite;
}
</style>